import { AutomationModal } from './components/automationModal/automationModal';
import { ComposeEmailModal } from './components/composeEmailModal/composeEmailModal';
import { ConfirmModal } from './components/confirmModal/confirmModal';
import { ConversationPreviewModal } from './components/conversationPreviewModal/conversationPreviewModal';
import { ConversationQueueTransferModal } from './components/conversationQueueTransferModal/conversationQueueTransferModal';
import { ConversationsBulkModal } from './components/conversationsBulkModal/conversationsBulkModal';
import { CopilotTrialIntroModal } from './components/copilotTrialIntroModal/copilotTrialIntroModal';
import { CopilotTrialOutroModal } from './components/copilotTrialOutroModal/copilotTrialOutroModal';
import { CreateTagModal } from './components/createTagModal/createTagModal';
import { DesktopAppNoticeModal } from './components/desktopAppNoticeModal/desktopAppNoticeModal';
import { DesktopAppPwaNoticeModal } from './components/desktopAppPwaNoticeModal/desktopAppPwaNoticeModal';
import { ElevioResolutionModal } from './components/elevioResolutionModal/elevioResolutionModal';
import { FeedbackModal } from './components/feedbackModal/feedbackModal';
import { KeyCombinationRecorderModal } from './components/keyCombinationRecorderModal/keyCombinationRecorderModal';
import { KeyboardCheatSheetModal } from './components/keyboardCheatSheetModal/keyboardCheatSheetModal';
import { LogOutModal } from './components/logOutModal/logOutModal';
import { MergeContactsModal } from './components/mergeContactsModal/mergeContactsModal';
import { MicrophoneErrorModal } from './components/microphoneErrorModal/microphoneErrorModal';
import { NetworkConnectionLostModal } from './components/networkConnectionLostModal/networkConnectionLostModal';
import { OAuthProviderConfigurationModal } from './components/oauthProviderConfigurationModal';
import { ThirdPartyIntegrationConfigurationModal } from './components/thirdPartyIntegrationConfigurationModal';
import { WebSocketConnectionChangedModal } from './components/webSocketConnectionChangedModal/webSocketConnectionChangedModal';
import { WebSocketHealthCheckModal } from './components/webSocketHealthCheckModal/webSocketHealthCheckModal';
/**
 * A component that encapsulates the modals of the app.
 *
 * This is made as a component in order to support feature flagging as the
 * feature flag hook needs to be consumed after it has been initialized by the
 * app.
 */
export const AppModals = (): JSX.Element => {
  return (
    <>
      <ConfirmModal />
      <ConversationPreviewModal />
      <ConversationQueueTransferModal />
      <ConversationsBulkModal />
      <CreateTagModal />
      <DesktopAppPwaNoticeModal />
      <DesktopAppNoticeModal />
      <LogOutModal />
      <MicrophoneErrorModal />
      <NetworkConnectionLostModal />
      <WebSocketConnectionChangedModal />
      <WebSocketHealthCheckModal />
      <FeedbackModal />
      <MergeContactsModal />
      <KeyboardCheatSheetModal />
      <KeyCombinationRecorderModal />
      <ElevioResolutionModal />
      <CopilotTrialIntroModal />
      <CopilotTrialOutroModal />
      <ThirdPartyIntegrationConfigurationModal />
      <OAuthProviderConfigurationModal />
      <AutomationModal />
      <ComposeEmailModal />
    </>
  );
};
